import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

import { API_BASE, authHeaders } from "@/lib/api";

/**
 * Anteprima PDF di un documento del fascicolo via <iframe> su blob URL
 * (autenticato). Riusata dal completamento documento (drawer L2).
 */
export function PdfPreview({ fileId }: { fileId: string | null }) {
  const [url, setUrl] = useState<string | null>(null);
  const [errore, setErrore] = useState(false);

  useEffect(() => {
    if (!fileId) {
      setUrl(null);
      return;
    }
    let revoked: string | null = null;
    let alive = true;
    setErrore(false);
    setUrl(null);
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/v1/m3/documenti/${fileId}/scarica`, {
          headers: await authHeaders(),
        });
        if (!res.ok) throw new Error(String(res.status));
        const blob = await res.blob();
        if (!alive) return;
        const obj = URL.createObjectURL(blob);
        revoked = obj;
        setUrl(obj);
      } catch {
        if (alive) setErrore(true);
      }
    })();
    return () => {
      alive = false;
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [fileId]);

  if (!fileId)
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Nessuna anteprima ancora.
      </div>
    );
  if (errore)
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Anteprima non disponibile.
      </div>
    );
  if (!url)
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  // #view=FitH adatta il PDF alla larghezza del riquadro (leggibilità); zoom=page-width
  // è l'equivalente per pdf.js (Firefox). navpanes=0 nasconde la sidebar miniature.
  return (
    <iframe
      title="Anteprima documento"
      src={`${url}#view=FitH&zoom=page-width&navpanes=0`}
      className="h-full w-full border-0"
    />
  );
}
